export default __webpack_public_path__ + "static/media/react-native.af665d37.svg";